import { Component, OnInit } from '@angular/core';
import { AwsService } from '../../providers/appsyncservice/aws.service';

@Component({
  selector: 'app-alertlogscreen',
  templateUrl: './alertlogscreen.component.html',
  styleUrls: ['./alertlogscreen.component.css']
})
export class AlertlogscreenComponent implements OnInit {


  soslist: any;
  editsos: any;
  displayValue: Number;
  iconFlag: Boolean;
  sosid: String;
  sosstatus : any;

  constructor(public awserviceProvider: AwsService) {
    this.getlist();
  }

  getlist() {
    //var sosAll :any[]=[];
    this.awserviceProvider.getScSosListAll().then(sosdata => {
      var sosAll = sosdata;

      sosAll.forEach(sos => {
        this.awserviceProvider.getRncUsers(sos.user_id).then(user => {
          sos.user = {}
          sos.user = user;
        });
        this.awserviceProvider.getRncUsers(sos.driver_id).then(driver => {
          sos.driver = {}
          sos.driver = driver;
        });
        this.awserviceProvider.getScTripMasterById(sos.trip_id).then(trip => {
          sos.trip = {}
          sos.trip = trip;
        });

        console.log("SOSSSSSSSSS", sos);
        this.soslist.push(sos);

      });


    });
  }

  ngOnInit() {
    this.displayValue = 0;
    this.iconFlag = false;
    this.sosid = "";
    this.soslist = [];
    this.sosstatus = [{ id: 0, name: "Open" }, { id: 1, name: "Closed" }];
  }

  addComment(sos) {
    //this.displayValue = 1;
    this.editsos = sos;
    this.iconFlag = true;
    this.sosid = sos.id;

  }

  saveComment(sos) {
    this.displayValue = 0;
    console.log(sos);
    this.iconFlag = false;
    this.sosid = "";
    //console.log("sossossossossossos",sos)
    this.awserviceProvider.UpdateScSos(sos).then(result => {
     // this.getlist();

    }).catch(err => {
      console.log("err",err)
    });

  }


}
